import React from "react";
import {imageCdnUrls} from "./ImageCdnUrls";

const LoadingOverlay = () => {
    return (
        <div className="modal is-active loading-overlay">
            <div className="modal-background"/>
            <div className="modal-card modal-content">
                <section className="modal-card-body">
                    <img src={imageCdnUrls.small_loader} width="100" height="100"/>
                </section>
            </div>
        </div>
    );
};

export default LoadingOverlay;
